import React from "react";

import {
	Section,
	Content,
	Title,
	Description,
	ResultsGrid,
	ResultBox,
	Value,
	Label,
	BackgroundImage,
} from "./styles";
import { HighlightBar } from "../HighlightBar";
import { useWindowSize } from "../../../hooks/useWindowResize";
import { size } from "../../../constants";

export default function DeliveredResult({
	backgroundImage,
	backgroundImageMobile,
	results,
	description,
	title,
}) {
	const { width } = useWindowSize();
	const isMobile = width <= size.laptop;

	return (
		<Section backgroundImage={backgroundImage}>
			{backgroundImage && (
				<BackgroundImage
					src={width < size.laptop ? backgroundImageMobile : backgroundImage}
					aria-hidden="true"
				/>
			)}
			<div className="container-blog">
				<Content>
					<div className="bar">
						<HighlightBar />
					</div>
					<Title dangerouslySetInnerHTML={{ __html: title }} />
					<Description dangerouslySetInnerHTML={{ __html: description }} />
					<ResultsGrid>
						{results.map((item) => (
							<ResultBox key={item.id || item.label}>
								<Value dangerouslySetInnerHTML={{ __html: item.value }} />
								<Label dangerouslySetInnerHTML={{ __html: item.label }} />
							</ResultBox>
						))}
					</ResultsGrid>
				</Content>
			</div>
		</Section>
	);
}
